// AxisConfig.js
class AxisConfig {
  constructor(options = {}) {
    this.config = {
      style: {
        labelAutoRotate: false,
        labelAutoWrap: true,
        labelFill: options?.color??'#000',
        labelFontSize: options?.fontSize??12,
        labelFontFamily: "Inter, sans-serif",
        labelFontWeight: 600,
        labelFillOpacity: 1,
        maxWidth: 30,
        transform: ['overlapDodgeX']
      },
      label: {
        style: {
            fill: options?.color??'#000',
            fontSize: options?.fontSize??12,
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            maxWidth: 30
        }
      }
    };
  }

  getConfig() {
    return this.config;
  }

  setLabelOption(key, value) {
    if (this.config.label.hasOwnProperty(key)) {
      this.config.label[key] = value;
    }
    return this;
  }

  setLabelStyle(key, value) {
    if (!this.config.label.style) {
      this.config.label.style = {};
    }
    this.config.label.style[key] = value;
    return this;
  }

  setLabelFontSize(size) {
    return this.setLabelStyle('fontSize', size);
  }

  setLabelFontColor(color) {
    return this.setLabelStyle('fill', color);
  }

  setLabelFontFamily(fontFamily) {
    return this.setLabelStyle('fontFamily', fontFamily);
  }

  setOption(key, value) {
    this.config[key] = value;
    return this;
  }
}

export default AxisConfig;